
import Vue from "vue";
import { MemberRole } from "../models/Member";

export default Vue.extend({
  name: "ManageMemberEditModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    member: {
      type: Object as () => any,
      default: null,
    },
    companies: {
      type: Array as () => Array<{ id: number; title: string }>,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      memberEmail: "",
      role: "",
      profileImageUrl: "",
      statusUser: false,
      selectedCompanyIds: [] as number[],
    };
  },
  computed: {
    roles() {
      return [MemberRole.OWNER, MemberRole.OWNER_RVS, MemberRole.MEMBER, MemberRole.SUPERMEMBER];
    },
    localDialog: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    save() {
      this.$emit("onSubmit", {
        email: this.memberEmail,
        role: this.role,
        name: this.member?.name || "",
        profileImageUrl: this.profileImageUrl,
        status: this.statusUser ? "active" : "inactive",
        company_ids: this.selectedCompanyIds,
      });
    },
    onChangeImage() {
      (this as any).$refs.file.click();
    },
    async onChange(e: any) {
      try {
        const file = e.target.files[0];
        const imageType = e.target.files[0].type;

        if (!["image/jpeg", "image/jpg", "image/png"].includes(imageType)) {
          return alert("Please upload file with type: jpeg, jpg, png");
        }

        let formdata = new FormData();
        formdata.append("image_file", file, `image_profile_${Math.floor(Math.random() * (10000 - 1 + 1)) + 1}`);

        const { url } = await (this as any).$dep.memberUseCase.uploadProfileImage(formdata);
        this.profileImageUrl = url;
      } catch (error) {
        //
      }
    },
  },
  watch: {
    value(open: boolean) {
      if (open && this.member) {
        this.memberEmail = this.member.email || "";
        this.role = this.member.role || "";
        this.profileImageUrl = this.member.profileImageUrl || "";
        this.statusUser = this.member.status === "active";
        this.selectedCompanyIds = Array.isArray(this.member.companies) ? [...this.member.companies] : [];
      }
    },
  },
});
